(function() {
  if (window.__attachmentBoxBound) return;
  window.__attachmentBoxBound = true;

  // ponytail: single global map keyed by pending-key. Survives multiple bindBox calls.
  window.__pendingFilesMap = {};

  function humanSize(bytes) {
    if (!bytes) return '0 B';
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1048576) return (bytes / 1024).toFixed(1) + ' KB';
    if (bytes < 1073741824) return (bytes / 1048576).toFixed(1) + ' MB';
    return (bytes / 1073741824).toFixed(1) + ' GB';
  }

  function getCsrf() {
    var m = document.querySelector('meta[name="csrf-token"]');
    return m ? m.getAttribute('content') : '';
  }

  function pendingFiles($pendingList) {
    var arr = [];
    $pendingList.children('li').each(function() {
      var key = $(this).data('pending-key');
      if (key && window.__pendingFilesMap[key]) arr.push(window.__pendingFilesMap[key]);
    });
    return arr;
  }

  var pendingKeyCounter = 0;

  function bindBox($box) {
    if ($box.data('bound')) return;
    $box.data('bound', true);

    var lessonId = $box.data('lesson-id');
    var courseId = $box.data('course-id');
    var $drop = $box.find('.attachment-drop-zone');
    var $input = $box.find('.attachment-file-input');
    var $pick = $box.find('.attachment-pick');
    var $pendingList = $box.find('.attachment-pending-list');
    var $uploadBtn = $box.find('.attachment-upload-btn');
    var $list = $box.find('.attachment-list');

    function refreshUploadButton() {
      var enabled = pendingFiles($pendingList).length > 0 && !!lessonId;
      $uploadBtn.prop('disabled', !enabled);
      if (enabled) {
        $uploadBtn.removeAttr('disabled');
      } else {
        $uploadBtn.attr('disabled', 'disabled');
      }
    }

    function addPendingFiles(files) {
      Array.prototype.slice.call(files).forEach(function(file) {
        var key = ++pendingKeyCounter;
        window.__pendingFilesMap[key] = file;
        var $li = $('<li/>');
        $li.data('pending-key', key);
        $li.html(
          '<i class="fas fa-paperclip"></i> ' + file.name +
          ' <small class="text-muted">(' + humanSize(file.size) + ')</small>' +
          '<button type="button" class="attachment-cancel-btn" title="Quitar"><i class="fas fa-times"></i></button>'
        );
        $li.find('.attachment-cancel-btn').on('click', function() {
          delete window.__pendingFilesMap[key];
          $li.remove();
          refreshUploadButton();
        });
        $pendingList.append($li);
      });
      refreshUploadButton();
    }

    $drop.on('dragover dragenter', function(e) {
      e.preventDefault();
      e.stopPropagation();
      $drop.addClass('dragover');
    });
    $drop.on('dragleave drop mouseleave', function(e) {
      e.preventDefault();
      e.stopPropagation();
      $drop.removeClass('dragover');
    });
    $drop.on('drop', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var dt = e.originalEvent.dataTransfer;
      if (dt && dt.files && dt.files.length) addPendingFiles(dt.files);
    });

    $pick.on('click', function(e) {
      e.preventDefault();
      $input.trigger('click');
    });
    $input.on('change', function() {
      if (this.files && this.files.length) addPendingFiles(this.files);
      $input.val('');
    });

    $uploadBtn.on('click', function() {
      var files = pendingFiles($pendingList);
      if (!files.length || !lessonId) return;

      var fd = new FormData();
      files.forEach(function(f) { fd.append('files[]', f); });

      $uploadBtn.prop('disabled', true).html('<i class="fas fa-spinner fa-spin"></i> Subiendo...');

      $.ajax({
        url: '/courses/' + courseId + '/lessons/' + lessonId + '/attach_files',
        method: 'POST',
        data: fd,
        processData: false,
        contentType: false,
        headers: { 'X-CSRF-Token': getCsrf(), 'Accept': 'application/json' }
      }).done(function(response) {
        $pendingList.children('li').each(function() {
          delete window.__pendingFilesMap[$(this).data('pending-key')];
        });
        $pendingList.empty();
        renderAttachments($list, response.attachments || []);
      }).fail(function(xhr) {
        var body = xhr.responseText || '';
        alert('Error al subir archivos: ' + xhr.status);
        console.error('[attach_files]', xhr.status, body);
      }).always(function() {
        $uploadBtn.prop('disabled', false).html('<i class="fas fa-upload"></i> Cargar archivos');
        refreshUploadButton();
      });
    });

    $box.on('click', '.attachment-remove-btn', function() {
      var $btn = $(this);
      var attachmentId = $btn.data('attachment-id');
      if (!lessonId || !attachmentId) return;
      if (!confirm('¿Quitar este archivo?')) return;
      $.ajax({
        url: '/courses/' + courseId + '/lessons/' + lessonId + '/remove_attachment',
        method: 'DELETE',
        data: { attachment_id: attachmentId },
        headers: { 'X-CSRF-Token': getCsrf(), 'Accept': 'application/json' }
      }).done(function(response) {
        renderAttachments($list, response.attachments || []);
      }).fail(function() {
        alert('Error al quitar archivo');
      });
    });
  }

  function renderAttachments($list, attachments) {
    $list.empty();
    attachments.forEach(function(att) {
      var $li = $('<li data-attachment-id="' + att.id + '"></li>');
      $li.html(
        '<i class="fas fa-paperclip"></i> ' +
        '<a href="' + att.url + '" target="_blank">' + att.filename + '</a>' +
        ' <small class="text-muted">(' + humanSize(att.byte_size) + ')</small>' +
        '<button type="button" class="attachment-remove-btn" data-attachment-id="' + att.id + '" title="Quitar"><i class="fas fa-times"></i></button>'
      );
      $list.append($li);
    });
  }

  function bindAll(root) {
    var $root = root ? $(root) : $(document);
    $root.find('.attachment-box').each(function() {
      if (!$(this).data('bound')) bindBox($(this));
    });
  }

  window.bindAttachmentBoxes = bindAll;

  $(function() { bindAll(); });
  $(document).on('turbolinks:load', function() { bindAll(); });
  $(document).on('DOMContentLoaded', function() { bindAll(); });
})();